import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Col, Row, Grid } from 'react-styled-flexboxgrid'

import { useTranslation } from 'i18n-web/i18next'
import Text from 'components/Atoms/Text'

const Component = styled.div`
  background-color: ${props => props.theme.palette.grayLight};
`

const Title = styled(Text)`
  font-size: ${props => props.theme.font.size.mobile.h4};
  line-height: 110%;
  margin-bottom: 5px;
`

const Header = ({ title, subtitle }) => {
  const { t } = useTranslation()

  return (
    <Component>
      <Grid>
        <Row center="xs" className="main">
          <Col xs={12}>
            <Title className="bold">
              {t('payBySignage.welcomeTo')} {title}
            </Title>
            {subtitle && <Text className="small semiBold">{subtitle}</Text>}
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default Header
